const ALL_REFERENCE_PATTERN = /\[(@?[A-Z0-9_#]+)\]/g;

function getNodeRaw(node) {
  return node.raw || node.expression || node.text || '';
}

function extractReferences(node) {
  const raw = getNodeRaw(node);
  const references = [];
  let match;

  ALL_REFERENCE_PATTERN.lastIndex = 0;

  while ((match = ALL_REFERENCE_PATTERN.exec(raw)) !== null) {
    references.push({
      variable: match[1],
      line: node.line,
      nodeType: node.type,
      raw,
    });
  }

  return references;
}

export function generateAllReferenceReport(ast) {
  const references = ast.nodes.flatMap(extractReferences);

  return {
    totalReferences: references.length,
    references,
  };
}
